/**
 * Browser-safe configuration types and utilities
 *
 * This module contains only browser-safe code (no fs, path, url imports).
 * For Node.js-specific utilities like loadConfig, import from './config'.
 */

/**
 * Brixon configuration interface
 */
export interface BrixonConfig {
  /** Presentation metadata */
  presentation: {
    /** Unique slug for the presentation URL */
    slug: string
    /** Display title */
    title: string
    /** Optional subtitle */
    subtitle?: string
    /** Client name */
    clientName?: string
  }
  /** Build options */
  build?: {
    /** Output directory (default: dist) */
    outDir?: string
    /** Minify output (default: true) */
    minify?: boolean
  }
  /** Dev server options */
  dev?: {
    /** Port number (default: 3000) */
    port?: number
  }
  /** Deploy options */
  deploy?: {
    /** API key for authentication */
    apiKey?: string
  }
}

/**
 * Define a type-safe Brixon configuration
 *
 * @example
 * ```typescript
 * // brixon.config.ts
 * import { defineConfig } from '@brixon-group/presentation-sdk'
 *
 * export default defineConfig({
 *   presentation: {
 *     slug: 'acme-pitch',
 *     title: 'ACME Digital Transformation',
 *     clientName: 'ACME Corporation',
 *   },
 * })
 * ```
 */
export function defineConfig(config: BrixonConfig): BrixonConfig {
  return config
}
